import {
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
  OnChanges,
} from '@angular/core';
import {
  ConfigPackageList,
  DataListModel,
  PackingFilterModel,
} from '@kanzi-apes/kanzi-models';
import { LazyLoadEvent } from '@kanzi-apes/kanzi-prime-ui';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import { PacketListService } from './packet-list.service';

@Component({
    selector: 'kanzi-apes-package-list',
    templateUrl: './kanzi-package-list.component.html',
    styleUrls: ['./kanzi-package-list.component.scss'],
    standalone: false
})
export class KanziPackageListComponent implements OnChanges {
  @Input() configuration: ConfigPackageList | null;
  @Input() dataSource: DataListModel | null;
  @Input() loading: boolean;
  @Output() packSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() onloadLazy: EventEmitter<PackingFilterModel> =
    new EventEmitter<PackingFilterModel>();
  @Output() packingSearch: EventEmitter<string> = new EventEmitter<string>();

  envService: EnvironmentService = inject(EnvironmentService);
  countPacket = 0;
  countItems = 0;
  searchPackageValue = '';

  constructor(private readonly packetListService: PacketListService) {
    this.configuration = null;
    this.dataSource = null;
    this.loading = false;
  }

  ngOnChanges(): void {
    if (this.dataSource && this.countPacket === 0 && this.countItems === 0) {
      this.countPacket = this.dataSource
        ? this.dataSource.count
          ? this.dataSource.count
          : 0
        : 0;
      this.countItems = this.dataSource.results
        .map((res) => res.total_amount)
        .reduce((total, value) => total + value);
    }
  }

  loadLazy(event$: LazyLoadEvent) {
    let pag = 0;
    if (event$.first !== undefined && event$.rows !== undefined) {
      pag = event$.first / event$.rows + 1;
    }
    const filter: PackingFilterModel = {
      page: pag,
      page_size: event$.rows,
    };
    console.log('filter', filter);
    this.onloadLazy.emit(filter);
  }

  selectPack(pack: any) {
    this.packSelected.emit(pack);
  }

  /**
   *
   * @param event {KeyboardEvent} - Event triggered when the user types in the autocomplete input.
   * @description This method emits the search query to the parent component when the user types in the autocomplete input.
   */
  onCompleteSearch(event: KeyboardEvent) {
    if (event && this.searchPackageValue.length > 2) {
      this.packingSearch.emit(this.searchPackageValue);
    }
  }
}
